import React, {useEffect, useMemo} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import reportUtils from "../../../../../utils/report-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const EventByAgent = ({data}) => {
    const eventByAgent = data.closuresByAgent ?? []

    const top10 = useMemo(() => {
        const localData = eventByAgent.slice(0, 10);

        return {
            labels: localData.map(item => item.name),
            values: localData.map(item => item.qty)
        };
    }, [eventByAgent]);

    const eventToExport = useMemo(() => {
        return {
            labels: eventByAgent.map(item => item.name),
            values: eventByAgent.map(item => item.qty)
        };
    }, [eventByAgent]);

    useEffect(() => {
        if (top10.labels.length > 0) {
            GraphicUtils.barChart('event-by-agent', top10.values, top10.labels);
        }

        if (eventToExport.labels.length > 0) {
            ReportUtils.createExportableTable(eventToExport.labels, eventToExport.values, `Encerramentos por agente`);
        }

    }, [top10, eventToExport]);

    return (
        <>
            <div className="chart-report" title={"Tipo do evento"}>
                <span id={`event-by-agent-title`} className="chart-title " htmlFor={"event-by-agent"} >Encerramentos de eventos por agente {eventToExport.labels.length > 9 ? "(TOP 10)" : "" }</span>
                <div className="mt-3" id={"event-by-agent"}></div>
            </div>
        </>
    );
};

export default EventByAgent;